<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search ref="buttonSearch" placeholder="要搜索的订单编号" @search="searchEvent" class="pt-3 pb-1">
			<!-- 左边 -->
			<template #left>
				<!-- <el-button type="primary" size="mini" icon="el-icon-plus" @click="navigate('rcgl_ddcl_jhdd_create')">下单</el-button>
				<el-button type="danger" size="mini" icon="el-icon-delete">删除</el-button>
				<el-button type="primary" size="mini" @click="opcta(multipleSelection)" icon="el-icon-s-promotion" style="margin-right: 10px;">发送消息</el-button>
				<el-select v-model="dqck" filterable style="width: 100px;" size="mini" @change="curr">
				    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select> -->
				<!-- <el-dropdown class="ml-2 mr-2">
					<el-button type="success" icon="el-icon-s-promotion" size="mini">审核</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item><div style="color: #7c7eff;font-size: 12px;" @click="states(1, multipleSelection)">同意</div></el-dropdown-item>
						<el-dropdown-item><div style="color: #d00003;font-size: 12px;" @click="states(2, multipleSelection)">拒绝</div></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="success" size="mini" @click="ckds('xsgl_ddcl_xsckd_create',multipleSelection)" icon="el-icon-position">添加出库</el-button>
				<el-button type="success" size="mini" @click="opctb(multipleSelection)" icon="el-icon-finished">收款确认</el-button>
				<el-button type="success" size="mini" icon="el-icon-document-copy">选择开票</el-button> -->
			</template>

			<!-- 高级搜索表单 -->
			<template #form>
				<!-- <el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="客户名" class="mb-0">
						<el-select v-model="search.kh_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户简称" class="mb-0">
						<el-select v-model="search.kh_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="批次号" class="mb-0"><el-input v-model="search.pch" placeholder="批次号" size="mini"></el-input></el-form-item>
					<el-form-item label="时间区间" class="mb-0">
						<el-date-picker v-model="search.kstime" type="date" placeholder="开始时间" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
						<span class="mx-2">-</span>
						<el-date-picker v-model="search.jstime" type="date" placeholder="结束时间" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form> -->
			</template>
		</button-search>

		<el-tabs v-model="tabIndex" @tab-click="getList">
			<el-tab-pane :key="tabI" v-for="(tab, tabI) in tabbars">
				<span slot="label" class="d-flex">
					<div style="">{{tab.name}}</div>
					<div v-if="tab.num != 0" style="background: #ffa303;width: 24px;height: 18px;border-radius: 10px;margin-top: 6px;justify-content: center;align-items: center;" class="d-flex">
						<div style="font-size: 10px;color: #fff;font-weight: 800;">{{tab.num}}</div>
					</div>
				</span>
			</el-tab-pane>
		</el-tabs>

		<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight">
			<!-- <el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="bh" width="90" label="编号" fixed="left"></el-table-column>
			
			<el-table-column align="center" width="110" label="客户名">
				<template slot-scope="scope">
					{{ scope.row.khdata.name }}
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="日期">
				<template slot-scope="scope">
					{{ scope.row.ddrq }}
				</template>
			</el-table-column>
			
			<el-table-column align="center" prop="hwxm" width="70" label="货物项目"></el-table-column>
			<el-table-column type="expand" label="明细表" width="60">
				<template slot-scope="scope">
					<el-table :data="scope.row.rcddhw" stripe style="padding-left: 100px;" size="mini" :header-cell-style="{ background: '#f4faf4' }">
						<el-table-column prop="bh" label="编号" width="160"></el-table-column>
						<el-table-column prop="bzjf" label="包装叫法" width="80"></el-table-column>
						<el-table-column prop="js" label="件数" width="80" align="center"></el-table-column>
						<el-table-column prop="jfsl" label="计费数量" width="80" align="center"></el-table-column>
						<el-table-column prop="bsl" label="板数量" width="80" align="center"></el-table-column>
					</el-table>
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="计费数量">
				<template slot-scope="scope">
					<div>{{ scope.row.jfsl }}<span style="margin-left: 4px;color: #007bff;">{{ scope.row.jfdwdata.name }}</span></div>
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="合计">
				<template slot-scope="scope">
					<div>{{ scope.row.hj }}<span style="margin-left: 4px;color: #007bff;">{{ scope.row.jfdwdata.name }}</span></div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="zyf" width="80" label="总运费"></el-table-column>
			<el-table-column align="center" width="80" label="货物类型">
				<template slot-scope="scope">
					{{ scope.row.hwlxdata.name }}
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="仓库">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" plain>{{ scope.row.ckdata.name }}</el-button>
				</template>
			</el-table-column> -->
			<!-- <el-table-column align="center" width="80" label="储存方式">
				<template slot-scope="scope">
					{{ scope.row.ccfsdata.name }}
				</template>
			</el-table-column> -->
			<!-- <el-table-column align="center" width="80" label="计费标准">
				<template slot-scope="scope">
					{{ scope.row.jfbzdata.name }}
				</template>
			</el-table-column>
			<el-table-column align="center" width="80" label="计费单位">
				<template slot-scope="scope">
					{{ scope.row.jfdwdata.name }}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="jfzq" width="90" label="计费周期"></el-table-column>
			<el-table-column align="center" width="90" label="经手人">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{ scope.row.cjrdata.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="收发员">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{ scope.row.sfydata == null ? '无' : scope.row.sfydata.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="仓管">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{ scope.row.ckglydata == null ? '无' : scope.row.ckglydata.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="80" label="分类费用">
				<template slot-scope="scope">
					<el-button :type="scope.row.flfy == 1 ? 'success' : 'warning'" :icon="scope.row.flfy == 1 ? 'el-icon-check' : 'el-icon-close'" circle size="mini"></el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="80" label="过车费">
				<template slot-scope="scope">
					<el-button :type="scope.row.gcf == 1 ? 'success' : 'warning'" :icon="scope.row.gcf == 1 ? 'el-icon-check' : 'el-icon-close'" circle size="mini"></el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="80" label="运费">
				<template slot-scope="scope">
					<el-button :type="scope.row.yf == 1 ? 'success' : 'warning'" :icon="scope.row.yf == 1 ? 'el-icon-check' : 'el-icon-close'" circle size="mini"></el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="80" label="拉膜费">
				<template slot-scope="scope">
					<el-button :type="scope.row.lmf == 1 ? 'success' : 'warning'" :icon="scope.row.lmf == 1 ? 'el-icon-check' : 'el-icon-close'" circle size="mini"></el-button>
				</template>
			</el-table-column> -->
			<!-- 操作 -->
			<!-- <el-table-column align="center" label="操作" fixed="right" width="190">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="navigate('rcgl_ddcl_jhdd_create',scope.row)">编辑</el-button>
					<el-select v-model="value" placeholder="更多" size="mini" style="width: 75px;margin-left: 10px;">
						<el-option value="1"><p @click="openModel('fpzxg',scope.row)" :style="{  color: scope.row.fpzx == 0 ? '#fa0000': '#0057fa' }">分配装卸工</p></el-option>
						<el-option value="2" v-if="scope.row.flfy != 0"><p @click="openModel('fpfly',scope.row)" :style="{  color: scope.row.fpfl == 0 ? '#fa0000': '#0057fa' }">分配分类员</p></el-option>
						<el-option value="3"><p @click="openModel('fplhy',scope.row)" :style="{  color: scope.row.fplh == 0 ? '#fa0000': '#0057fa' }">分配理货员</p></el-option>
						<el-option value="4"><p @click="openModel('rczb',scope.row)" :style="{  color: scope.row.dlr == 0 ? '#fa0000': '#0057fa' }">入仓坐标</p></el-option>
						<el-option value="5"><p @click="qrrc(scope.row)" :style="{  color: scope.row.qrrc == 0 ? '#fa0000': '#0057fa' }">确认入仓</p></el-option>
						<el-option value="6"><p @click="qrwc(scope.row)" :style="{  color: scope.row.shzt == 0 ? '#fa0000': '#0057fa' }">完成订单</p></el-option>
						<el-option value="7"><p @click="printData(scope.row)">打印订单</p></el-option>
					</el-select>
				</template>
			</el-table-column> -->
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
<!-- 
		<el-drawer title="企业微信消息发送" :visible.sync="drawera" :direction="direction" size="600px">
			<div class="ml-4 mr-4" style="width: 100%;">
				<el-form ref="form" label-width="80px">
					<el-form-item label="信息数量"><el-input v-model="form.xxsl" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="标题字段">
						<el-select v-model="form.btzd" placeholder="请选择" size="mini">
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="消息标题"><el-input v-model="form.xxbt" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="卡片描述">
						<el-select v-model="form.kpms" placeholder="请选择" size="mini">
							<el-option v-for="item in optionss" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="卡片链接"><el-input v-model="form.kplj" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="接收对象">
						<el-radio-group v-model="form.jsdx" size="mini">
							<el-radio-button label="0">个人</el-radio-button>
							<el-radio-button label="1">部门</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="选择范围">
						<el-select v-model="form.xzfw" filterable placeholder="请选择">
						    <el-option v-for="item in grlist" :key="item.id" :label="item.name" :value="item.id" v-if="form.jsdx == 0"></el-option>
							<el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id" v-else></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer> -->
		<el-drawer title="结算" :visible.sync="drawerb" :direction="direction" size="400px">
			<div class="ml-4 mr-4" style="width: 100%;">
				<div style="font-size: 14px;color: #cbcbcb;margin-left: 10px;">待结算金额：{{num}}</div>
				<el-form ref="formb" label-width="80px">
					<el-form-item label="信息数量"><el-input-number v-model="formb.num" size="mini" :min="0" :max="num"></el-input-number></el-form-item>
					<el-form-item label="结算账户">
						<el-select v-model="formb.cwzj" placeholder="请选择" size="mini">
							<el-option v-for="item in cwzjlist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
						<div class="mt-3"><el-button type="primary" size="mini" @click="tjcw">确定提交</el-button></div>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer>
		<el-dialog title="分配装卸工" :visible.sync="createModel" top="10vh" :before-close="handleClose">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<el-select v-model="xzzxg" multiple placeholder="请选择" size="mini" filterable collapse-tags>
					<el-option v-for="item in zxglist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-button type="primary" @click="onSubmit" size="mini" style="margin-left: 10px;">添加装卸工</el-button>
				<div class="ml-2">剩余数量：<span style='margin-right: 3px;' :style="{  color: formzxg.ce < 0 ? '#fa0000': '#0057fa' }">{{formzxg.ce}}</span>吨</div>
			</div>
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-table :data="formzxg.list" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
					<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
					<el-table-column label="数量" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.sl" style="width: 90%;" :min='0' :precision="2" @change="handjstj"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" fixed="right" width="100">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" @click="delzxg(scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="gbym">取 消</el-button>
				<el-button type="primary" @click="qrfp('zxg')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="分配分类员" :visible.sync="createModelfl" top="10vh" :before-close="handleClose">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<el-select v-model="xzfly" multiple placeholder="请选择" size="mini" filterable collapse-tags>
					<el-option v-for="item in flylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-button type="primary" @click="onSubmitfl" size="mini" style="margin-left: 10px;">添加分类员</el-button>
				<div class="ml-2">剩余数量：<span style='margin-right: 3px;' :style="{  color: formfly.ce < 0 ? '#fa0000': '#0057fa' }">{{formfly.ce}}</span>吨</div>
			</div>
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-table :data="formfly.list" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
					<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
					<el-table-column label="数量" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.sl" style="width: 90%;" :min='0' :precision="2" @change="handjsfl"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" fixed="right" width="100">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" @click="delfly(scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="gbym">取 消</el-button>
				<el-button type="primary" @click="qrfp('fly')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="分配理货员" :visible.sync="createModellh" top="10vh" :before-close="handleClose">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<el-select v-model="xzlhy" multiple placeholder="请选择" size="mini" filterable collapse-tags>
					<el-option v-for="item in lhylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-button type="primary" @click="onSubmitlhy" size="mini" style="margin-left: 10px;">添加理货员</el-button>
				<div class="ml-2">剩余数量：<span :style="{  color: formlhy.ce < 0 ? '#fa0000': '#0057fa' }">{{formlhy.ce}}</span></div>
			</div>
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-table :data="formlhy.list" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
					<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
					<el-table-column label="数量" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.sl" style="width: 90%;" :min='0' :precision="2" @change="handjstjlhy"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="理货类型" align="center">
						<template slot-scope="scope">
							<el-select v-model="scope.row.lhlx" style="width: 100%;" size="mini">
							    <el-option v-for="item in lhlxlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" fixed="right" width="100">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" @click="dellhy(scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="gbym">取 消</el-button>
				<el-button type="primary" @click="qrfp('lhy')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="录入货物坐标" :visible.sync="createModelzb" top="10vh" width="80%" :before-close="handleClose">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<el-select v-model="xzhw" multiple placeholder="请选择" size="mini" filterable collapse-tags style="width: 300px;">
					<el-option v-for="item in hwlist" :key="item.id" :label="item.hwmc" :value="item.id">
						<div class="d-flex w-100">
							<span style="width: 50%;">{{ item.hwmc }}</span>
							<span style="width: 25%; color: #8492a6; font-size: 13px;">{{ item.syrksl }}</span>
							<span style="float: right; color: #8492a6; font-size: 13px;">{{ item.syrkjs }}/件</span>
						</div>
					</el-option>
				</el-select>
				<el-button type="primary" @click="onSubmitlhw" size="mini" style="margin-left: 10px;">添加入仓记录</el-button>
			</div>
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-table :data="formhw" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
					<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
					<el-table-column prop="name" label="名称" width="120"></el-table-column>
					<el-table-column label="数量" align="center" width="170">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.js" style="width: 90%;" :min='0' @change="handhwjs(scope.row.js,scope.$index,scope.row.cd,scope.row.kd,scope.row.gd,scope.row.mjzl)"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="重量" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.sl}}
						</template>
					</el-table-column>
					<el-table-column label="面积" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.mj}}
						</template>
					</el-table-column>
					<el-table-column label="体积" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.tj}}
						</template>
					</el-table-column>
					<el-table-column label="坐标" align="center">
						<template slot-scope="scope">
							<el-cascader v-model="scope.row.zb" :options="kczblist" :props="{ expandTrigger: 'hover' }" size="mini" style="width: 90%;"></el-cascader>
						</template>
					</el-table-column>
					
					<el-table-column align="center" label="操作" fixed="right" width="100">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" @click="dellrzb(scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div style="margin-top: 20px;font-weight: 800;">需入库货物表</div>
			<div style="width: 100%;" class="d-flex">
				<el-table :data="hwlist" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
					<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
					<el-table-column prop="hwmc" label="货物名称" width="120"></el-table-column>
					<el-table-column label="编号" align="center" width="150">
						<template slot-scope="scope">
							{{scope.row.bh}}
						</template>
					</el-table-column>
					<el-table-column label="数量" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.js}}
						</template>
					</el-table-column>
					<el-table-column label="面积" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.mj}}
						</template>
					</el-table-column>
					<el-table-column label="体积" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.tj}}
						</template>
					</el-table-column>
					<el-table-column label="重量(吨)" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.zzl}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="gbym">取 消</el-button>
				<el-button type="primary" @click="qrfp('rcdw')">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<!-- 打印模板 -->
		<div class="print-div none" id="print_area" media="print">
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 25%;">{{dydd.thlxdata.name}}</div>
				<div style="width: 20%;">???</div>
				<div style="width: 35%;font-size: 24px;">入仓单</div>
				<div style="width: 20%;">编号：<span style="font-size: 18px;font-weight: 800;">{{dydd.bh}}</span></div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 50%;">客户名称：{{dydd.khdata.name}}</div>
				<div style="width: 26%;">入仓日期：{{dydd.ddrq}}</div>
				<div style="width: 12%;">{{dydd.hwlxdata.name}}</div>
				<div style="width: 12%;">{{dydd.ckdata.name}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 22%;">存储方式：{{dydd.ccfsdata.name}}</div>
				<div style="width: 78%;">备注：{{dydd.desc}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">货物名称</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">货物编码</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">客称</div>
				<div style="width: 24%;display: flex;justify-content: center; align-items: center;">包装叫法</div>
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;">件数</div>
				<div style="width: 14%;display: flex;justify-content: center; align-items: center;">包装/附注</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in dydd.rcddhw">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">{{item.hwmc}}</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">{{item.bh}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.kc}}</div>
				<div style="width: 24%;display: flex;justify-content: center; align-items: center;">{{item.bzjf}}</div>
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;">{{item.js}}</div>
				<div style="width: 14%;display: flex;justify-content: center; align-items: center;">{{item.hwbzdata.name}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 40%;">运费：<span style="margin-right: 4px;">{{dydd.zyf}}</span>元</div>
				<div style="width: 20%;">合计板数：<span style="margin-right: 4px;">{{dydd.hwzbs}}</span>板</div>
				<div style="width: 20%;">合计：<span style="margin-right: 4px;">{{dydd.hwzds}}</span>吨</div>
				<div style="width: 20%;">合计件数：{{dydd.hwzjs}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 34%;display: flex;font-size: 13px;margin-bottom: 4px;">广州诚晖冷冻食品物流有限公司</div>
				<div style="width: 66%;display: flex;font-size: 13px;">电话：0757-85709188，85709200，85709201，17708636608</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;">
				<div style="width: 25%;">收货：</div>
				<div style="width: 25%;">制单：{{dydd.cjrdata.name}}</div>
				<div style="width: 25%;">复核：</div>
				<div style="width: 25%;">签收人：</div>
			</div>
		</div>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			dydd:{
				thlxdata:{
					name:''
				},
				khdata:{
					name:''
				},
				ckdata:{
					name:''
				},
				hwlxdata:{
					name:''
				},
				ccfsdata:{
					name:''
				},
				cjrdata:{
					name:''
				},
				rcddhw:[]
			},
			multipleSelection: [],
			createModel: false,
			createModellh: false,
			createModelzb: false,
			createModelfl: false,
			preUrl: 'jh_rcdd',
			maxHeight: 0,
			tabIndex: 0,
			tableData: [],
			khlist:[],
			tabbars: [
				{ name: '全部订单', key: 'all' ,num:0},
				{ name: '待领取', key: 'dlq' ,num:0},
				{ name: '预收单', key: 'ysd' ,num:0},
				{ name: '待入仓', key: 'drc' ,num:0},
				{ name: '加急单', key: 'jjd' ,num:0},
				{ name: '待录入', key: 'dlr' ,num:0},
				{ name: '待审核', key: 'dsh' ,num:0},
				{ name: '已完成', key: 'ywc' ,num:0}
			],
			drawera: false,
			grlist:[],
			bmlist:[],
			lhlxlist:[],
			cwzjlist:[],
			
			search: {
				keyword: "",
				jstime:'',
				kstime:'',
				kh_id:'',
				pch:''
			},
			form: {},
			formb: {},	
			value: '更多',
			drawerb: false,
			direction: 'rtl',
			options: [
				{
					id: 0,
					name: '订单号'
				},
				{
					id: 1,
					name: '商品总额'
				},
				{
					id: 2,
					name: '订单金额'
				},
				{
					id: 3,
					name: '待结算金额'
				},
				{
					id: 4,
					name: '产品数量'
				},
				{
					id: 5,
					name: '客户'
				},
				{
					id: 6,
					name: '审核状态'
				},
				{
					id: 7,
					name: '出库状态'
				},
				{
					id: 8,
					name: '收款状态'
				},
				{
					id: 9,
					name: '业务员'
				},
				{
					id: 10,
					name: '下单时间'
				}
			],
			optionss: [
				{
					id: 0,
					name: '您有新的消息，请点击进入详情查看。'
				},
				{
					id: 1,
					name: '您有新的订单，请及时处理。'
				},
				{
					id: 2,
					name: '您有新的工作，请查看。'
				}
			],
			num: 99,
			formzxg:{
				id:'',
				sysl:0,
				ce:0,
				list:[]
			},
			zxglist:[],
			xzzxg:[],
			formfly:{
				id:'',
				sysl:0,
				ce:0,
				list:[]
			},
			flylist:[],
			xzfly:[],
			formlhy:{
				id:'',
				sysl:0,
				ce:0,
				list:[]
			},
			lhylist:[],
			xzlhy:[],
			dqck:0,
			cklist:[],
			formhw:[],
			hwlist:[],
			xzhw:[],
			hwck:'',
			kczblist:[]
		};
	},
	filters: {

	},
	computed: {
		...mapState({
			user: state => state.user.user
		}),
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 296;
		});
		this.axios.get('/admin/managers/list',{
			token: true
		}).then(res => {
			this.grlist = res.data.data
		})
		this.axios.get('/admin/bumens/list',{
			token: true
		}).then(res => {
			this.bmlist = res.data.data
		})
		this.axios.get('/admin/cwzj/1',{
			token: true
		}).then(res => {
			this.cwzjlist = res.data.data.list
		})
		
		
		
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
		this.axios.get('/admin/lhlx/1', { token: true }).then(res => {
			this.lhlxlist = res.data.data.list;
		});
		this.axios.get('/admin/zxglist', { token: true }).then(res => {
			this.zxglist = res.data.data;
			this.zxglist.push(this.user)
		});
		this.axios.get('/admin/lhylist', { token: true }).then(res => {
			this.lhylist = res.data.data;
			this.lhylist.push(this.user)
		});
		this.axios.get('/admin/flylist', { token: true }).then(res => {
			this.flylist = res.data.data;
			this.flylist.push(this.user)
		});
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
			this.cklist.unshift({
				id: 0,
				name: '全部'
			})
		});
	},
	methods: {
		curr(val){
			this.dqck = val
			this.getList()
		},
		getList() {
			if(this.preUrl == '') return
			this.showLoading()
			let url = this.getListUrl()
			this.axios.get(url, { // 商品规格 api
				token: true
			}).then(res => {
				let data = res.data.data
				this.page.total = data.totalCount // 获取分页信息
				// console.log(data)
				this.getListResult(data) // 获取到的数据储存到getListResult(data)，方便外面调用修改
				this.tabbars[1].num = data.dlq
				this.tabbars[2].num = data.ysd
				this.tabbars[3].num = data.drc
				this.tabbars[4].num = data.jjd
				this.tabbars[5].num = data.dlr
				this.tabbars[6].num = data.dsh
				this.hideLoading()
			}).catch(err => {
				this.hideLoading()
			})
		},
		states(e, f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else if (f[0].shzt == 1) {
				return this.$message({
					type: 'error',
					message: '订单已完成审核'
				});
			}else{
				let x = f.map(i => {
					return i.id;
				});
				let i = {
					shzt: e,
					ids: x
				};
				this.axios.post('/admin/xxdd/update_status', i,{
					token: true
				}).then(res => {
					this.getList()
				})
			}
			
		},
		ckds(name, e) {
			
			if(e.length == 0){
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else if(e.length > 1){
				return this.$message({
					type: 'error',
					message: '请选择一张订单'
				});
			}else if(e[0].shzt == 0){
				return this.$message({
					type: 'error',
					message: '订单尚未审核'
				});
			}else if(e[0].shzt == 2){
				return this.$message({
					type: 'error',
					message: '订单审核不通过'
				});
			}else {
				e = e[0]
				var data = {
					bm:e.bm.id,
					cjr:e.cjr.id,
					ckcps:e.ckcps,
					ddh:"自动生成",
					bdsqd:e.ddh,
					id:e.id,
					desc:"",
					djlx:"销售出库单",
					ywy:e.ywy.id,
					kh:e.kh.id,
					ckcw:e.ckcw.id,
					spze:e.spze,
					ddje:e.ddje,
					cpsl:e.cpsl,
					skzh:e.skzh,
					xin:0
				};
				this.$router.push({
					name,
					params: { data }
				});
			}
			
			
			
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 鼠标单击的事件
		navigate(name, e) {
			
			// 初始化表单
			if (!e) {
				const now = new Date();
				const year = now.getFullYear();
				const month = now.getMonth() + 1; // 月份从0开始，需要加1
				const day = now.getDate();
				const today = year +'-'+month+'-'+day
				var data = {
					id:0,
					kh_id:'',
					bh:'',
					ddrq:today,
					ccfs:'',
					jfbz:'',
					hwlx:'',
					jfdw:'',
					jfzq:1,
					ddsx:0,
					ck_id:this.user.ck_id,
					flfy:'',
					gcf:'',
					yf:'',
					lmf:'',
					lmfdj:0,
					desc:'',
					hwxm:0,
					jfsl:0,
					hj:0,
					zyf:0,
					jfms:0,
					dqzt:0,
					sfyh:0,
					lcf:0,
					zflfy:0,
					zgcf:0,
					zlmf:0,
					sfjj:0,
					sfy:'',
					cjr: this.user.id,
					pch:'',
					hwzjs:0,
					hwzds:0,
					hwzmj:0,
					hwzbs:0,
					hwztj:0,
					rcddhw:[],
					zzl:0,
					flfylx:0,
					thlx:'',
					thlx_sl_zc:0,
				};
			} else {
				var data = {
					id:e.id,
					kh_id:e.kh_id,
					bh:e.bh,
					ddrq:e.ddrq,
					ccfs:e.ccfs,
					jfbz:e.jfbz,
					hwlx:e.hwlx,
					jfdw:e.jfdw,
					jfzq:e.jfzq,
					ddsx:e.ddsx,
					ck_id:e.ck_id,
					flfy:e.flfy == 0 ? false : true,
					gcf:e.gcf == 0 ? false : true,
					yf:e.yf == 0 ? false : true,
					lmf:e.lmf == 0 ? false : true,
					lmfdj:e.lmfdj,
					desc:e.desc,
					hwxm:e.hwxm,
					jfsl:e.jfsl,
					hj:e.hj,
					zyf:e.zyf,
					dqzt:e.dqzt,
					sfyh:e.sfyh,
					lcf:e.lcf,
					zflfy:e.zflfy,
					zgcf:e.zgcf,
					zlmf:e.zlmf,
					sfjj:e.sfjj,
					sfy:e.sfy,
					cjr: e.cjr,
					rcddhw:e.rcddhw,
					pch:e.pch,
					jfms:e.jfms,
					hwzjs:e.hwzjs,
					hwzds:e.hwzds,
					hwzmj:e.hwzmj,
					hwzbs:e.hwzbs,
					hwztj:e.hwztj,
					zzl:e.zzl,
					flfylx:e.flfylx,
					thlx:e.thlx,
					thlx_sl_zc:e.thlx_sl_zc,
				};
			}
			this.$router.push({
				name,
				params: { data }
			});
		},

		gotos(e,f) {
			console.log(f)
			var data = {
				scbh:'自动生成',
				ddlx: 1,
				desc: '',
				ywy: '',
				jhkssj: '',
				jhwcsj: '',
				scddcp: [],
				sclx: '',
				scz: '',
				xxdd: f.ddh,
				sfwb: 0,
				wbgys: '',
				id:'',
				cpsl:0,
				cjr: this.user.id
			};
			this.$router.push({
				name: e,
				query: {
					ddlx: 1,
					data:data
				}
			});
		},

		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}&keyword=${this.search.keyword}&kh_id=${this.search.kh_id}&dqck=${this.dqck}&pch=${this.search.pch}&kstime=${this.search.kstime}&jstime=${this.search.jstime}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list
			this.tabbars[1].num = e.dlq
			this.tabbars[2].num = e.ysd
			this.tabbars[3].num = e.drc
			this.tabbars[4].num = e.jjd
			this.tabbars[5].num = e.dlr
			this.tabbars[6].num = e.dsh
		},


		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search.keyword = e
				this.getList()
				return
			}
			// 高级搜索
			this.getList()
		},

		opcta(f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else{
				this.form = {
					xxsl:f.length,
					btzd:0,
					xxbt:'',
					kpms:'',
					kplj:'',
					jsdx:0,
					xzfw:''
				}
				this.drawera = true;
			}
		},
		opctb(e) {
			if (e.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else if(e.length > 1){
				return this.$message({
					type: 'error',
					message: '只能选择一张订单操作'
				});
			}else if(e[0].djsje == 0){
				return this.$message({
					type: 'error',
					message: '订单已完成收款'
				});
			}else{
				this.num = e[0].djsje,
				this.formb = {
					num:0,
					cwzj:'',
					djlx:'产品销售收入',
					skzt:0
				}
				this.drawerb = true;
			}
		},
		
		tjcw(){
			let zt = this.multipleSelection[0]['djsje'] - this.formb.num
			if(zt == 0){
				this.formb.skzt = 2
			}else{
				this.formb.skzt = 1
			}
			let x = {
				data:this.multipleSelection[0],
				cwmx:this.formb,
				cjr:this.user.id,
				srlb:4
			}
			this.axios.post('/admin/xxdd/cwmx', x, {
				token: true
			}).then(res => {
				this.$message({
					type: "success",
					message: "收款成功"
				})
				this.getList()
			})
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				keyword: "",
				jstime:'',
				kstime:'',
				kh_id:'',
				pch:''
			}
		},
		openModel(type, item = false) {
			if(type == 'fpzxg'){ // 分配装卸工
				if (item) {
					if(item.zxg.length == 0){
						this.formzxg.ce = parseFloat(item.zzl)
					}else{
						let num = 0
						for(let i of item.zxg){
							num += parseFloat(i.sl)
						}
						this.formzxg.ce = parseFloat(item.zzl) - num.toFixed(2)
					}
					this.formzxg.list = item.zxg
					this.formzxg.sysl = parseFloat(item.zzl)
					this.formzxg.id = item.id
				}
				// 打开dialog
				this.createModel = true;
			}else if(type == 'fpfly'){ // 分配分类员
				if (item) {
					
					if(item.fly.length == 0){
						this.formfly.ce = parseFloat(item.zzl)
					}else{
						let num = 0
						for(let i of item.fly){
							num += parseFloat(i.sl)
						}
						this.formfly.ce = parseFloat(item.zzl) - num.toFixed(2)
					}
					this.formfly.list = item.fly
					this.formfly.sysl = parseFloat(item.zzl)
					this.formfly.id = item.id
				}
				// 打开dialog
				this.createModelfl = true;
			}else if(type == 'fplhy'){ // 分配理货员
				if (item) {
					if(item.lhy.length == 0){
						this.formlhy.ce = parseFloat(item.zzl)
					}else{
						let num = 0
						for(let i of item.lhy){
							num += parseFloat(i.sl)
						}
						this.formlhy.ce = parseFloat(item.zzl) - num.toFixed(2)
					}
					this.formlhy.list = item.lhy
					this.formlhy.sysl = parseFloat(item.zzl)
					this.formlhy.id = item.id
				}
				// 打开dialog
				this.createModellh = true;
			}else if(type == 'rczb'){
				if (item) {
					this.hwlist = item.rcddhw
					this.hwck = item.ck_id
					this.axios.get('/admin/hwls/'+item.id, { token: true }).then(res => {
						this.formhw = res.data.data;
					});
					this.axios.get('/admin/ckdw/' + item.ck_id, { token: true }).then(res => {
						let data = res.data.data.filter(items=>{
							return items.id == item.ck_id
						})
						let dd = data.map(aa=>{
							return  {
								value:aa.id,
								label:aa.name,
								children:aa.child.map(bb=>{
									return  {
										value:bb.id,
										label:bb.name,
										children:bb.child.map(cc=>{
											return  {
												value:cc.id,
												label:cc.name,
												children:cc.child.map(dd=>{
													return  {
														value:dd.id,
														label:dd.name,
														children:dd.child.map(ee=>{
															return  {
																value:ee.id,
																label:ee.name,
																children:ee.child.map(ff=>{
																	return  {
																		value:ff.id,
																		label:ff.name
																	}
																})
															}
														})
													}
												})
											}
										})
									}
								})
							}
						})
						this.kczblist = dd
					});
				}
				// 打开dialog
				this.createModelzb = true;
			}
		},
		onSubmit(){
			for(let i of this.xzzxg){
				let name = this.zxglist.filter(item=>{
					return item.id == i
				})
				let data = {
					rcdd_id: this.formzxg.id,
					zxg_id: i,
					id:0,
					name:name[0].name,
					sl:parseFloat(this.formzxg.sysl / this.xzzxg.length).toFixed(2)
				}
				this.formzxg.list.push(data)
			}
			
			this.handjstj()
			this.xzzxg = []
		},
		onSubmitfl(){
			for(let i of this.xzfly){
				let name = this.flylist.filter(item=>{
					return item.id == i
				})
				let data = {
					rcdd_id: this.formfly.id,
					fly_id: i,
					id:0,
					name:name[0].name,
					sl:parseFloat(this.formfly.sysl / this.xzfly.length).toFixed(2)
				}
				this.formfly.list.push(data)
			}
			
			this.handjsfl()
			this.xzfly = []
		},
		onSubmitlhy(){
			let ds = []
			for(let i of this.xzlhy){
				let name = this.lhylist.filter(item=>{
					return item.id == i
				})
				let data = {
					rcdd_id: this.formlhy.id,
					lhy_id: i,
					id:0,
					name:name[0].name,
					sl:parseFloat(this.formlhy.sysl / this.xzlhy.length).toFixed(2),
					lhlx:1
				}
				ds.push(data)
			}
			this.formlhy.list = ds
			this.handjstjlhy()
			this.xzlhy = []
		},
		onSubmitlhw(){
			for(let i of this.xzhw){
				let name = this.hwlist.filter(item=>{
					return item.id == i
				})
				let data = {
					id:0,
					rcdd_id: name[0].rcdd_id,
					cjr: this.user.id,
					bh:name[0].bh,
					ck:this.hwck,
					name:name[0].hwmc,
					sl:0,
					js:0,
					mj:0,
					cd:name[0].cd,
					kd:name[0].kd,
					gd:name[0].gd,
					mjzl:name[0].mjzl,
					mjmj:name[0].djmj,
					mjtj:name[0].djtj,
					tj:0,
					zb:0,
					ck_k:'',
					ck_q:'',
					ck_h:'',
					ck_l:''
				}
				this.formhw.push(data)
			}
			this.xzhw = []
		},
		handjstj(){
			let num = 0
			for(let i of this.formzxg.list){
				num = num + parseFloat(i.sl)
			}
			this.formzxg.ce = parseFloat(this.formzxg.sysl - num).toFixed(2)
		},
		handjsfl(){
			let num = 0
			for(let i of this.formfly.list){
				num = num + parseFloat(i.sl)
			}
			this.formfly.ce = parseFloat(this.formfly.sysl - num).toFixed(2)
		},
		handhwjs(js,index,cd,kd,gd,mjzl){
			mjzl = mjzl / 1000
			this.formhw[index].mj = (cd * kd * js).toFixed(2)
			this.formhw[index].tj = (cd * kd * gd * js).toFixed(2)
			this.formhw[index].sl = (mjzl * js).toFixed(2)
		},
		handjstjlhy(){
			let num = 0
			for(let i of this.formlhy.list){
				num = num + parseFloat(i.sl)
			}
			this.formlhy.ce = parseFloat(this.formlhy.sysl - num).toFixed(2)
		},
		gbym(){
			this.value = '更多'
			this.formzxg = {
				id:'',
				sysl:0,
				ce:0,
				list:[]
			},
			this.formlhy = {
				id:'',
				sysl:0,
				ce:0,
				list:[]
			},
			this.formhw = []
			this.hwlist = []
			this.createModel = false
			this.createModellh = false
			this.createModelzb = false
			this.createModelfl = false
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
					this.value = '更多'
					this.formzxg = {
						id:'',
						sysl:0,
						ce:0,
						list:[]
					}
					this.formlhy = {
						id:'',
						sysl:0,
						ce:0,
						list:[]
					}
				})
				.catch(_ => {});
		},
		qrfp(type){
			if(type == 'zxg'){
				this.axios.post('/admin/zxgfp/rcdd', this.formzxg, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "分配成功"
					})
					this.getList()
					this.value = '更多'
					this.formzxg = {
						id:'',
						sysl:0,
						ce:0,
						list:[]
					},
					this.xzzxg = []
					this.createModel = false
				})
			}else if(type == 'fly'){
				this.axios.post('/admin/flyfp/rcdd', this.formfly, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "分配成功"
					})
					this.getList()
					this.value = '更多'
					this.formfly = {
						id:'',
						sysl:0,
						ce:0,
						list:[]
					},
					this.xzfly = []
					this.createModelfl = false
				})
			}else if(type == 'lhy'){
				this.axios.post('/admin/lhyfp/rcdd', this.formlhy, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "分配成功"
					})
					this.getList()
					this.value = '更多'
					this.formlhy = {
						id:'',
						sysl:0,
						ce:0,
						list:[]
					},
					this.xzlhy = []
					this.createModellh = false
				})
			}else if(type == 'rcdw'){
				this.formhw = this.formhw.map(item=>{
					let num = 0
					for(let i of item.zb){
						if(num == 0){
							item.ck = i
							num += 1
						}else if(num == 1){
							item.ck_k = i
							num += 1
						}else if(num == 2){
							item.ck_q = i
							num += 1
						}else if(num == 3){
							item.ck_h = i
							num += 1
						}else if(num == 4){
							item.ck_l = i
							num += 1
						}else if(num == 5){
							item.zb = i
						}
					}
					return item
				})
				let data = {
					list:this.formhw,
					rcdd_id: this.formhw[0].rcdd_id
				}
				this.axios.post('/admin/hwsb/rcdd', data, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "上板成功"
					})
					this.getList()
					this.value = '更多'
					this.formhw = []
					this.xzhw = []
					this.createModelzb = false
				})
			}
			
		},
		delzxg(e,f){
			console.log(e,f)
		},
		delfly(e,f){
			console.log(e,f)
		},
		dellrzb(e,f){
			this.formhw.splice(f, 1);
		},
		qrrc(e){
			this.$confirm('是否确认货物已入库完毕?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.get('/admin/qrrk/'+e.id, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "入库成功"
					})
					this.getList()
					this.value = '更多'
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
			
		},
		qrwc(e){
			this.$confirm('是否确认订单审核通过?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.get('/admin/jh_qrwc/'+e.id, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "订单完成"
					})
					this.getList()
					this.value = '更多'
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
		},
		printData(e){
			this.dydd = e
			console.log(e)
			setTimeout(()=> {
				const style = '@page {  } ' +'@media print { .print-div{ padding:8px;background-color:#cccccc; }' ;
				printJS({
					printable: 'print_area',
					type: 'html',
					style: style,// 亦可使用引入的外部css;
					scanStyles: false
				})
				this.value = '更多'
			}, 1000);
		},
		
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
</style>
